<template>
  <div>
    <Table border :columns="columns" :data="data" ref="Table" id="Table" :loading="loading">
      <template slot-scope="{ row, index }" slot="achTypeUser" style="width:100%">
        <Select v-model="row.achTypeUser" :transfer="true" @on-change="targetItemChange(row, index, 'achTypeUser')">
          <Option v-for="item in BeSTI" :value="item.code" :key="item.code">{{ item.ch_value}}</Option>
        </Select>
      </template>
      <template slot-scope="{ row, index }" slot="achStage" style="width:100%">
        <Select v-model="row.achStage" :transfer="true" @on-change="targetItemChange(row, index, 'achStage')">
          <Option v-for="item in ProcessAchStage" :value="item.code" :key="item.code">{{ item.ch_value}}</Option>
        </Select>
      </template>
      <template slot-scope="{ row, index }" slot="achTypeTarget">
        <Select v-model="row.achTypeTarget" :transfer="true" @on-change="targetItemChange(row, index, 'achTypeTarget')" >
          <Option v-for="item in TargetUpdateType" :value="item.code" :key="item.code">{{ item.ch_value }}</Option>
        </Select>
      </template>
      <template slot-scope="{ row, index }" slot="nodeNo">
        <Input type="textarea" v-model="row.nodeNo" :autosize="true" @on-change="targetItemChange(row, index, 'nodeNo')" />
      </template>
      <template slot-scope="{ row, index }" slot="approvalType">
        <Select v-model="row.approvalType" :transfer="true" @on-change="targetItemChange(row, index, 'approvalType')" >
          <Option v-for="item in ApprovalUserType" :value="item.code" :key="item.code">{{ item.ch_value }}</Option>
        </Select>
        <!-- <Input type="textarea" v-model="row.approvalType" :autosize="true" @on-change="targetItemChange(row, index, 'approvalType')"/> -->
      </template>
      <!-- <template slot-scope="{ row, index }" slot="approvalUserName">
        <Input type="textarea" v-model="row.approvalUserName" :autosize="true" @on-change="targetItemChange(row, index, 'approvalUserName')"/>
      </template> -->
      <template slot-scope="{ row, index }" slot="beReport">
        <Select v-model="row.beReport" :transfer="true" @on-change="targetItemChange(row, index, 'beReport')" >
          <Option v-for="item in YesOrNo" :value="item.code" :key="item.code">{{ item.ch_value }}</Option>
        </Select>
      </template>
      <template slot-scope="{ row, index }" slot="beLock">
        <Select v-model="row.beLock" :transfer="true" @on-change="targetItemChange(row, index, 'beLock')">
          <Option v-for="item in YesOrNo" :value="item.code" :key="item.code">{{ item.ch_value  }}</Option>
        </Select>
      </template>
      <template slot-scope="{ row, index }" slot="beUpdate">
        <Select v-model="row.beUpdate" :transfer="true"  @on-change="targetItemChange(row, index, 'beUpdate')">
          <Option v-for="item in YesOrNo" :value="item.code" :key="item.code">{{ item.ch_value }}</Option>
        </Select>
      </template>
      <template slot="action1" slot-scope="{ row, index }">
        <Button size="small" @click="onSaveRow(row, index)">保存</Button>
        <Button type="error" size="small" @click="onDeleteRow(row, index)">删除</Button>
      </template>
    </Table>
    <div style="display: flex;justify-content: space-between;margin-top: 30px;">
      <Page :total="total" @on-change="pageChange"></Page>
      <div>
        <Button style="margin-left:15px" @click="addRow">新增</Button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import DateUtil from "../../../util/DateUtil";
export default {
  data() {
    return {
      loading:false,
      date: new DateUtil(),
      pageInfo: {
        itemCount: 0,
        pageNo: 1,
        pageSize: 10
      },
      total: 0,
      columns: [
        {
          title: "员工绩效类型",
          slot: "achTypeUser",
          align: "center",
          minWidth: 140
        },
        {
          title: "绩效阶段",
          slot: "achStage",
          align: "center",
          minWidth: 140
        },
        {
          title: "目标修订绩效类型",
          slot: "achTypeTarget",
          align: "center",
          minWidth: 160
        },
        {
          title: "节点号",
          slot: "nodeNo",
          align: "center",
          minWidth: 130
        },
        {
          title: "审批人代码",
          slot: "approvalType",
          align: "center",
          minWidth: 150
        },
        // {
        //   title: "审批人名称",
        //   slot: "approvalUserName",
        //   align: "center",
        //   minWidth: 120
        // },
        {
          title: "是否导入",
          slot: "beReport",
          align: "center",
          minWidth: 120
        },
        {
          title: "是否锁定",
          slot: "beLock",
          align: "center",
          minWidth: 120
        },
        {
          title: "是否修订",
          slot: "beUpdate",
          align: "center",
          minWidth: 120
        },
        {
          title: "操作",
          slot: "action1",
          align: "center",
          minWidth: 140
        }
      ],
      data: [],
      BeSTI:[],
      ProcessAchStage:[],
      TargetUpdateType:[],
      YesOrNo:[],
      targetIndex:'',
      ApprovalUserType:[]
    };
  },
  created() {
    this.getListData()
    this.getData()
  },
  methods: {
    getListData(){
      axios.post("/approvalSetting/selectApprovalLabel", {}).then((res) => {
          if(res){
              this.BeSTI=res.BeSTI
              this.ProcessAchStage=res.ProcessAchStage
              this.TargetUpdateType=res.TargetUpdateType
              this.YesOrNo=res.YesOrNo
              this.ApprovalUserType=res.ApprovalUserType
          }
      })
    },
    getData(){
      this.loading=true
      axios.post("/approvalSetting/selectApprovalSetting", {...this.pageInfo}).then((res) => {
        this.loading=false
          if(res){
              this.data=res.data
              this.total = parseInt(res.pageInfo.total)
          }
      })
    },
    addRow(){
      this.data.push({
        achTypeUser:'',
        achStage:'',
        achTypeTarget:'',
        nodeNo:'',
        approvalType:'',
        approvalUserName:'',
        beReport:'',
        beLock:'',
        beUpdate:''
      })
    },
    targetItemChange(row, index, key) {
      this.targetIndex=index
      if(key=='approvalType'){
        this.ApprovalUserType.forEach(el => {
          if(el.code==row.approvalType){
            this.$set(this.data[index], 'approvalUserName', el.ch_value)
          }
        })
      }
      key && this.$set(this.data[index], key, row[`${key}`]);
    },
    onSaveRow(row,index){
      axios.post("/approvalSetting/saveApprovalSetting", row).then((res) => {
          if(res){
              this.$Message.success(res);
              this.getData()
          }
      })
    },
    onDeleteRow(row,index){
      if(row.id){
        axios.post("/approvalSetting/deleteApprovalSetting", {id:row.id}).then((res) => {
          if(res){
              this.$Message.success(res);
              this.getData()
          }
      })
      }else {
        this.data.splice(index,1)
      }
    },
    pageChange(val){
        this.pageInfo.pageNo = val;
        this.getData()
    },
  }
};
</script>

<style lang="less" scoped></style>



// WEBPACK FOOTER //
// src/components/process/SystemSettings/ApprovalProcess.vue